// extracted by mini-css-extract-plugin
export default {"marquee":"Marquee_marquee__4nbAi"};